 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import INTRODUCTION from '@/components/introduction'
 import CHAPTER001 from '@/components/chapter001'
 import LOVINGALLOFME from '@/components/lovingallofme'
 import CHAPTER002 from '@/components/chapter002'
 import SUGARAINTSOSWEET from '@/components/sugaraintsosweet'
 import CHAPTER003 from '@/components/chapter003'
 import ABOUTTHEAUTHOR20DAYSOFPLEASURE from '@/components/abouttheauthor20daysofpleasure'
 import CHAPTER004 from '@/components/chapter004'
 import HISBIGGESTFAN from '@/components/hisbiggestfan'
 import CHAPTER005 from '@/components/chapter005'
 import HEAVENCANBEHELL from '@/components/heavencanbehell'
 import CHAPTER006 from '@/components/chapter006'
 import SEASONOFTHEBLOOD from '@/components/seasonoftheblood'
 import CHAPTER007 from '@/components/chapter007'
 import ALPHAWARLOCKSCLAIM from '@/components/alphawarlocksclaim'
 import CHAPTER008 from '@/components/chapter008'
 import THETHINGSICOULDTELLYOU from '@/components/thethingsicouldtellyou'
 import CHAPTER009 from '@/components/chapter009'
 import INSERVICETOTHESENATOR from '@/components/inservicetothesenator'
 import CHAPTER010 from '@/components/chapter010'
 import SLJENNINGS from '@/components/sljennings'
 import CHAPTER011 from '@/components/chapter011'
 import WINGSOFAIR from '@/components/wingsofair'
 import CHAPTER012 from '@/components/chapter012'
 import THESWEETTREATOFLOVE from '@/components/thesweettreatoflove'
 import CHAPTER013 from '@/components/chapter013'
 import FROMASHES from '@/components/fromashes'
 import CHAPTER014 from '@/components/chapter014'
 import THEUNPINKABLE from '@/components/theunpinkable'
 import CHAPTER015 from '@/components/chapter015'
 import TOLOVELOVEAGAINMALACHISREPRISE from '@/components/toloveloveagainmalachisreprise'
 import CHAPTER016 from '@/components/chapter016'
 import ATFIRSTSIGHT from '@/components/atfirstsight'
 import CHAPTER017 from '@/components/chapter017'
 import CYSGODION from '@/components/cysgodion'
 import CHAPTER018 from '@/components/chapter018'
 import STILLLIFEWITHLOBSTER from '@/components/stilllifewithlobster'
 import CHAPTER019 from '@/components/chapter019'
 import MERRYLITTLETHINGS from '@/components/merrylittlethings'
 import CHAPTER020 from '@/components/chapter020'
 import BEBRAVEWITHME from '@/components/bebravewithme'
 import CHAPTER021 from '@/components/chapter021'
 import GEMINIRISING from '@/components/geminirising'
 import CHAPTER022 from '@/components/chapter022'
 import ONCEBITTEN from '@/components/oncebitten'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/lovingallofme",
 			"name" : "lovingallofme",
 			"component" : LOVINGALLOFME
 		},
 		{
 			"path" : "/chapter002",
 			"name" : "chapter002",
 			"component" : CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js